<template>
    <div class="am-check-number-modal">
    <a href="javascript:void(0)" @click="checkNumberPopup" title="Paid">
        <svg-icon icon="yes" class="am-glyphicon-blue am-glyphicon-medium"></svg-icon>
    </a>
    <modal :name='modalName' :clickToClose="false" width="450px" :pivotY="0.3" height="auto" :adaptive="true" classes="am-vue-modal">
    <div class="am-check-number">
        <div class="am-check-number-title-bar am-main-top-box">
            <span class="am-check-number-title am-main-top-box-title"><strong>Add a Check</strong></span>
        </div>
      <table class="am-check-number-table">
        <tbody>
        <tr>
          <strong><span>Check Number:</span></strong>
          <td>
            <div class="am-check-number-numberField">
              <input type="text" v-model="billedItem.checkNumber" @keypress="isValid = true,isWholeNumber($event)"  maxlength="6">
            </div>
            <div class='am-field-error' v-if="isValid && billedItem.checkNumber === ''">
              Check Number is Required
            </div>
            <div class='am-field-error' v-if="isValid && billedItem.checkNumber.length  < checkNumberMinLength">
              Invalid Check Number
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="am-check-number-blue-border"></div>
      <div class="am-check-number-align-bottom-buttons">
        <div class="am-check-number-float-right">
          <button type="button" class="btn btn-secondary" @click="closeModal">Cancel</button>
          <div class="am-check-number-divider"></div>
          <button type="button" class="btn btn-primary" @click="submitCheckNumber()">Submit</button>
        </div>
      </div>
    </div>
    </modal>
    </div>
</template>

<script>
import api from './../http'
export default {
  name: 'CheckNumber',
  data: function () {
    return {
      billedItem: {
        checkNumber: ''
      },
      isValid: false,
      checkNumberMinLength: 4
    }
  },
  props: {
    billingId: {
      type: Number,
      default: 0
    }
  },
  computed: {
    modalName () {
      return 'check-number-' + this.billingId
    }
  },
  methods: {
    closeModal () {
      this.$modal.hide(this.modalName)
    },

    checkNumberPopup () {
      this.$modal.show(this.modalName)
    },

    isWholeNumber (event) {
      event = (event) || window.event
      var charCode = (event.which) ? event.which : event.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault()
      } else {
        return true
      }
    },
    submitCheckNumber () {
      if (this.validateForm()) {
        let self = this
        api.postRequest('backoffice/processCheck/' + this.billingId, this.billedItem).then(function (response) {
          self.closeModal()
          location.reload()
        })
      }
    },
    validateForm () {
      this.displayErrorMessage()
      return (
        this.isValid &&
              this.billedItem.checkNumber.length >= this.checkNumberMinLength)
    },
    displayErrorMessage () {
      if (this.billedItem.checkNumber === '') {
        this.isValid = true
      }
    }
  }
}
</script>

<style scoped>
    .am-field-error {
        color: #ff6e40;
    }

    .am-check-number{
        width:650px;
        border: 1px lightgrey solid;
        color:black;
    }

    .am-check-number-title-bar {
        height: 35px;
    }
    .am-check-number-title {
        color: #FDFEFE;
        float: left;
        margin-top: 7px;
        margin-left: 15px;
        font-size: 14px;
    }
    .am-check-number-table {
        margin-left: 15px;
        margin-right: 40px;
        margin-top: 10px;
    }

    .am-check-number-table td {
        padding: 5px 0px 0px 20px;
    }
    .am-check-number-table td input, select{
        width: 200px;
        height:25px;
        margin-top: 5px;
        background-color: white;
    }

    .am-check-number-table tr span {
        display:block;
        margin-top: 10px;
    }

    .am-check-number-blue-border {
        display: block;
        width: 100%;
        border-top: 1px solid #4297d7;
        margin-top: 20px;
    }

    .am-check-number-align-bottom-buttons button{
        margin-top: 5px;
        margin-bottom: 5px;
    }
    .am-check-number-float-right {
        margin-left: 280px;
    }

    .am-check-number-divider   {
        width:5px;
        display:inline-block;
    }

    .am-check-number-modal{
        float:left;
        display:block;
        padding: 0px 3px 0px 0px
    }

    .am-check-number-numberField input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        margin: 0;
    }

</style>

<style>
  .am-vue-modal {
    background-color: white;
    text-align: left;
    border-radius: 0;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
    padding: 0;
  }
</style>
